/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { dateFormatWithLocale } from '../../../../../helpers/general';

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoMileage from "../../../../reportsNoMileage"
import { useLocaleContext } from '../../../../../contexts/localeContext';

/* Styles */
import styles from "./styles.js"

const getRowDescription = (gridValue) => {
  if (!gridValue) return "-";
  if (gridValue === "true" || gridValue.toLowerCase() === "yes")
    return <FormattedMessage id="complianceGrid.refundable.true"/>
  return <FormattedMessage id="complianceGrid.refundable.false"/>
};

const ComplianceGrid = (props) => {
  const {gridOptions, setGridOptions, mileageResponse, onRowClick} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const locale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.complianceGrid}>
      <UCGrid
        gridName="complianceGrid"
        data={ mileageResponse?.results }
        columns={ mileageResponse?.columns }
        actions={ mileageResponse?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        });
          page > 1 ? navigate(`/app/reports/compliance?page=${page}`) : navigate(`/app/reports/compliance`)
        }}
        setSelectedRow={setSelectedRow}
        spinner="complianceGridSpinner"
        customColumns={{
          refundable: (row) => {
            return row.refundable ? getRowDescription(row.refundable) : "-"
          },
          bookingDate: (row) => (
            dateFormatWithLocale(row.bookingDate, locale)
          ),
          checkInDate: (row) => (
            dateFormatWithLocale(row.checkInDate, locale)
          ),
          checkOutDate: (row) => (
            dateFormatWithLocale(row.checkOutDate, locale)
          ),
          cancellationDeadlineLocal: (row) => (
            dateFormatWithLocale(row.cancellationDeadlineLocal, locale)
          ),
          inPolicy: (row) => {
            return row.inPolicy ? getRowDescription(row.inPolicy) : "-"
          },
        }}
        columnCustomWidth={{
          cancellationDeadlineLocal: "300px !important",
          travelerName : "200px !important",
          teamName: "200px !important",
          refundable : "200px !important",
          violationDetails: "200px !important",
        }}
        noDataComponent={ <ReportsNoMileage descriptionId="reportsNoMileage.description.compliance.CHOICE"/> }
        showHeader={true}
        persistTableHead={false}
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default ComplianceGrid;
